import React, { useEffect, useRef } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { onMessageListener } from '../../firebase';
import ToastDisplay from './ToastDisplay/ToastDisplay';

const Notification = () => {
  const onClose = (toastId) => {
    toast.dismiss(toastId);
  };

  // Keep track of recent notifications to prevent duplicates
  const recentNotifications = useRef({});
  const DUPLICATE_THRESHOLD = 10000; // 5 seconds

  useEffect(() => {
    // Subscribe to messages and show notification when receiving a new one
    const unsubscribe = onMessageListener((payload) => {
      const title = payload?.notification?.title;
      const body = payload?.notification?.body;

      if (title && body) {
        // Create a key for this notification
        const notificationKey = `${title}-${body}`;
        const now = Date.now();

        // Check if we've shown this notification recently
        if (
          recentNotifications.current[notificationKey] &&
          now - recentNotifications.current[notificationKey] < DUPLICATE_THRESHOLD
        ) {
          return; // Skip showing duplicate notification
        }

        // Update the timestamp for this notification
        recentNotifications.current[notificationKey] = now;

        const toastId = toast(<ToastDisplay title={title} body={body} onClose={() => onClose(toastId)} />, {
          duration: 10000,
          position: 'top-right',
        });
      }
    });

    // Clear subscription when component is unmounted
    return () => unsubscribe();
  }, []);

  return (
    <Toaster
      toastOptions={{
        style: {
          padding: 0,
          margin: 0,
          background: 'none',
          boxShadow: 'none',
        },
      }}
    />
  );
};

export default Notification;
